import React, { useState } from "react";

const Formulario = ({ img, setImg, datos, setDatos, opcion }) => {
	const [fecha, setFecha] = useState(false);
	const handlerImg = (event) => {
		const imgInp = event.target.files[0];
		if (imgInp) {
			setImg(URL.createObjectURL(imgInp));
		}
	};

	const Handler = (event) => {
		const { name, value } = event.target;
		if (name === "tipoPersona" && value === "Persona Natural") {
			setDatos({ ...datos, tipoPersona: value, razon: "", rutEmpresa: "" });
			return;
		}
		setDatos({ ...datos, [name]: value });
	};

	const muestraTipoPersona =
		opcion === "Contrato Arriendo Mensual" ||
		opcion === "Contrato Arriendo Anual" ||
		opcion === "Contrato Arriendo 30 dias" ||
		opcion === "Contrato Bodega";
	const esPersonaNatural =
		muestraTipoPersona && datos.tipoPersona === "Persona Natural";

	const setFechaHoy = () => {
		setFecha(false);
		setDatos({ ...datos, fecha: "hoy" });
	};

	const setFechaExtacta = () => {
		setFecha(true);
		setDatos({ ...datos, fecha: "" });
	};

	return (
		<div className='row'>
			<div className='medium-6 columns'>
				{opcion == "Contrato Contabilidad" ? (
					<div className=''>
						<label className=''>Elige Tipo de Contrato</label>
						<select
							className=''
							id='exampleFormControlSelect1'
							value={datos.planContratado}
							name='planContratado'
							onChange={(e) => Handler(e)}
						>
							<option selected>Elige una opción...</option>
							<option value='Plan Básico'>Plan Básico</option>
							<option value='Plan Emprende'>Plan Emprende</option>
							<option value='Plan Pyme'>Plan Pyme</option>
							<option value='Contrato Remuneraciones'>
								Contrato Remuneraciones
							</option>
						</select>
					</div>
				) : null}
				{opcion == "Contrato Arriendo Mensual" || opcion == "Contrato Arriendo Anual" || opcion == "Contrato Arriendo 30 dias" ? <div>
					<label>
						Dirección de la Oficina
					</label>
					<select
							className=''
							id='exampleFormControlSelect1'
							value={datos.oficina}
							name='oficina'
							onChange={(e) => Handler(e)}
						>
							<option selected>Elige una opción...</option>
							<option value='Santiago Centro'>Santiago Centro</option>
							<option value='Providencia'>Providencia</option>
							<option value='Bodega Providencia'>Bodega Providencia</option>
						</select>
						</div> : null}
				{muestraTipoPersona ? (
					<div>
						<label>Tipo de Persona</label>
						<select
							value={datos.tipoPersona || "Persona Jurídica"}
							name='tipoPersona'
							onChange={(e) => Handler(e)}
						>
							<option value='Persona Jurídica'>Persona Jurídica</option>
							<option value='Persona Natural'>Persona Natural</option>
						</select>
					</div>
				) : null}
				<label>
					{esPersonaNatural ? "Nombre Completo" : "Nombre Representante"}
					<input
						type='text'
						placeholder='Nombre Completo Chacarero Hamburguesa'
						value={datos.nombre}
						name='nombre'
						onChange={(e) => Handler(e)}
					/>
				</label>
				<label>
					{esPersonaNatural ? "Rut" : "Rut de Representante Legal"}
					<input
						type='text'
						placeholder='17.123.123-K'
						value={datos.rut}
						name='rut'
						onChange={(e) => Handler(e)}
					/>
				</label>
				{esPersonaNatural ? null : (
					<div>
						<label>
							Razón Social Empresa
							<input
								type='text'
								placeholder='Nombre Completo SpA'
								value={datos.razon}
								name='razon'
								onChange={(e) => Handler(e)}
							/>
						</label>
						<label>
							Rut Empresa
							<input
								type='text'
								placeholder='76.717.904-9'
								value={datos.rutEmpresa}
								name='rutEmpresa'
								onChange={(e) => Handler(e)}
							/>
						</label>
					</div>
				)}
				<div className=''>
					<label className=''>Elige Nacionalidad</label>
					<select
						className=''
						id='exampleFormControlSelect1'
						value={datos.nacionalidad}
						name='nacionalidad'
						onChange={(e) => Handler(e)}
					>
						<option selected>Elige una opción...</option>
						<option value='Chilena'>Chilena</option>
						<option value='Extranjera'>Extranjera</option>
					</select>
				</div>
				<div>
					<label>Fecha</label>
					<input
						type='radio'
						id='html'
						name='fav_language'
						value='hoy'
						onClick={(e) => setFechaHoy(e)}
					/>
					<label for='html'>HOY</label>
					<input
						type='radio'
						id='html'
						name='fav_language'
						value='fecha exacta'
						onClick={(e) => setFechaExtacta(e)}
					/>
					<label for='html'>FECHA EXACTA</label>
				</div>
				{fecha ? (
					<label>
						Fecha
						<input
							type='text'
							placeholder='4 de Agosto de 1588'
							value={datos.fecha}
							name='fecha'
							onChange={(e) => Handler(e)}
						/>
					</label>
				) : null}
				{opcion == "Contrato Contabilidad" || opcion == "Contrato Bodega" ? null : (
					<div className='Prueba'>
						<label className=''>Sube Cédula de Identidad</label>
						<input
							className=''
							accept='image/*'
							type='file'
							id='imgInp'
							onChange={handlerImg}
						/>
					</div>
				)}
				{opcion == "Contrato Arriendo Mensual" || opcion == "Contrato Arriendo Anual" || opcion == "Contrato Arriendo 30 dias" ? <div><label>
						Correo Electrónico*
						<input
							type='email'
							placeholder='correo@gmail.com'
							value={datos.correo}
							name='correo'
							required
							onChange={(e) => Handler(e)}
						/>
					</label><label>
						Teléfono de Contacto*
						<input
							type='text'
							placeholder='+56953897615'
							value={datos.telefono}
							name='telefono'
							required
							onChange={(e) => Handler(e)}
						/>
					</label></div> : null}
				<br></br>
			</div>
			<div className='medium-6 columns ImagenCedula'>
				{opcion == "Contrato Contabilidad" || opcion == "Contrato Bodega" ? null : (
					<div>
						<h2>Cédula de Identidad</h2>
						<img
							id='blah'
							src={img}
							alt='Sube una Cedula y Previsualizala'
							style={{ height: "400px" }}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default Formulario;
